import { BANNER_TYPES, DSBanner } from '@elliemae/ds-banner';
import { getAppConfigValue } from '@elliemae/pui-app-sdk';
import { LaneTag, getEnvByLane } from '@frontend/utils';
import { useEffect, useMemo, useState } from 'react';

export const EnvNotificationHeader = () => {
  const laneTag = getAppConfigValue('laneTag') as LaneTag;
  const envName = useMemo(
    () => getEnvByLane(laneTag).toUpperCase().replace(/aws/i, ''),
    [laneTag],
  );
  const [isOpen, setOpen] = useState(laneTag !== 'p1');

  useEffect(() => {
    setOpen(laneTag !== 'p1');
  }, [laneTag]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    isOpen && (
      <DSBanner
        data-testid="ds-banner"
        containerProps={{ id: 'environment-notification-banner' }}
        isOpen={isOpen}
        label={`${envName} Environment`}
        type={BANNER_TYPES.INFO}
        onClose={handleClose}
      />
    )
  );
};
